import { civilDate, money, percent, pointsDiff, shareBps, signedMoney } from "./format";
import { LockedCell, Note } from "./Cells";

const originOf = (cost) => {
  const measurement = [
    Number.isSafeInteger(cost.measurement) ? `medição ${cost.measurement}` : null,
    cost.measurementDate ? civilDate(cost.measurementDate) : null,
  ].filter(Boolean).join(", ");
  const label = cost.trendSource === "ampli_obras_card" ? "tendência do Ampli Obras" : "tendência da última medição processada";
  return `${cost.wbsCode} · ${label}${measurement ? ` (${measurement})` : ""}`;
};

const annulmentNote = (annulments) => {
  const count = annulments?.count;
  if (!Number.isSafeInteger(count) || count <= 0) return null;
  return count === 1 ? "1 título anulado na Ampli" : `${count} títulos anulados na Ampli`;
};

const MarginRow = ({ obra }) => {
  const { cost, margin } = obra;
  if (!cost) {
    return <tr>
      <th scope="row"><span className="director-dashboard-cell__name">{obra.name}</span></th>
      <td className="director-dashboard-table__missing" colSpan={7}>Sem orçamento no Ampli Obras</td>
    </tr>;
  }
  const soldOnly = !margin || margin.soldOnly;
  const annulled = annulmentNote(cost.annulments);
  const overrunKnown = Number.isSafeInteger(cost.overrunCents);
  const overrunShare = overrunKnown ? shareBps(cost.overrunCents, cost.budgetIndexedCents) : null;
  let overrunTone;
  if (overrunKnown) overrunTone = cost.overrunCents > 0 ? "bad" : "good";
  return <tr>
    <th scope="row">
      <span className="director-dashboard-cell__name">{obra.name}</span>
      <Note>{originOf(cost)}</Note>
      {annulled && <Note>{annulled}</Note>}
    </th>
    <td>
      <span className="director-dashboard-cell__text">{money(margin?.revenueCents)}</span>
      {soldOnly && <Note>só o vendido</Note>}
    </td>
    <td>{money(cost.budgetIndexedCents)}</td>
    <td>{money(cost.trendCents)}</td>
    <td data-tone={overrunTone}>
      <span className="director-dashboard-cell__text">{signedMoney(cost.overrunCents)}</span>
      {overrunShare !== null && <Note>{`${percent(overrunShare)} do orçado`}</Note>}
    </td>
    <td>{soldOnly ? <LockedCell /> : percent(margin.budgetMarginBps)}</td>
    <td data-tone={!soldOnly && margin.trendMarginBps < 0 ? "bad" : undefined}>
      {soldOnly ? <LockedCell /> : percent(margin.trendMarginBps)}
    </td>
    <td data-tone={!soldOnly && margin.trendMarginBps < margin.budgetMarginBps ? "bad" : undefined}>
      {soldOnly ? "—" : pointsDiff(margin.budgetMarginBps, margin.trendMarginBps)}
    </td>
  </tr>;
};

const MarginTable = ({ data }) => {
  const totals = data.totals || {};
  const obras = data.obras || [];
  return <section className="director-section director-dashboard-margin" aria-labelledby="director-dashboard-margin-title">
    <header>
      <div>
        <span className="director-eyebrow">Margem orçada × tendência</span>
        <h2 id="director-dashboard-margin-title">A margem está se mantendo?</h2>
      </div>
      <p>
        Margem orçada usa o orçado indexado; margem pela tendência usa o custo que o Ampli Obras projeta hoje.
        A receita é o vendido no Sienge mais o estoque informado nas premissas.
      </p>
    </header>
    <div className="director-table-scroll">
      <table className="director-table director-dashboard-table" aria-label="Margem orçada e pela tendência por obra">
        <thead>
          <tr>
            <th scope="col">Obra</th>
            <th scope="col">Receita</th>
            <th scope="col">Orçado indexado</th>
            <th scope="col">Tendência</th>
            <th scope="col">Estouro</th>
            <th scope="col">Margem orçada</th>
            <th scope="col">Margem pela tendência</th>
            <th scope="col">Diferença</th>
          </tr>
        </thead>
        <tbody>
          {obras.map((obra) => <MarginRow key={obra.projectKey} obra={obra} />)}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row"><span className="director-dashboard-cell__name">Total das obras</span></th>
            <td>—</td>
            <td>{money(totals.budgetIndexedCents)}</td>
            <td>—</td>
            <td>{signedMoney(totals.overrunCents)}</td>
            <td>—</td>
            <td>—</td>
            <td>—</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </section>;
};

export default MarginTable;
